import { memo } from "react";
import DefaultFooter from "../DefaultFooter";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var FooterSection = /*#__PURE__*/memo(function (_ref) {
  var renderFooter = _ref.renderFooter;
  if (renderFooter) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: renderFooter()
    });
  }
  if (renderFooter === void 0) {
    return /*#__PURE__*/_jsx(DefaultFooter, {});
  }
  return null;
}, function (prev, cur) {
  return prev.renderFooter === cur.renderFooter;
});
export default FooterSection;